// extracted by mini-css-extract-plugin
export default {"dialogContent":"Gt6Fs4XfVg8E0ZGXJy_oO","drawerPaper":"_2qEmeqakaqwGPDmHLTC3kg"};